module.exports = __webpack_public_path__ + "a6fdbc1a432230d1ed8b315a641fc6d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/ir_38.jpg
// module id = 1710
// module chunks = 5